import { render, staticRenderFns } from "./AbkTagsBox.vue?vue&type=template&id=5ca800f8&scoped=true&"
import script from "./AbkTagsBox.vue?vue&type=script&lang=js&"
export * from "./AbkTagsBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkTagsBox.vue?vue&type=style&index=0&id=5ca800f8&lang=scss&scoped=true&"
import style1 from "./AbkTagsBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca800f8",
  null
  
)

export default component.exports